/* eslint-disable no-unused-vars */

export enum documentConstant {
  GET_FILES = 'GET_FILES',
  FETCH_DATA_FILES = 'FETCH_DATA_FILES',
  UPDATE_SELECT_FILE = 'UPDATE_SELECT_FILE',
  SELECT_ALL_FILE = 'SELECT_ALL_FILE',
  DELETE_FILES = 'DELETE_FILES',
  UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS',
  GET_READ_TOKEN = 'GET_READ_TOKEN',
  UPDATE_READ_TOKEN = 'UPDATE_READ_TOKEN',
}
